import * as React from 'react';
import { Preloader } from '@cian/valuation-component';

import * as styles from './styles.css';

interface IEstimationChartProps {
  title: React.ReactElement;
  chart: React.ReactElement;
  isDesktop: boolean;
  isLoading?: boolean;
}

export const EstimationChart = React.forwardRef<HTMLDivElement, IEstimationChartProps>((props, ref) => {
  const { title, chart, isLoading, isDesktop } = props;

  return (
    <div ref={ref} data-testid="estimationChartId" className={styles['container']}>
      {isDesktop ? title : null}
      <div data-testid="chartId" className={styles['chart']}>
        {chart}
      </div>
      {isLoading && <Preloader size={32} />}
    </div>
  );
});

EstimationChart.displayName = 'EstimationChart';
